import { k1Axios } from './axios';
import { PageableResponse, Organization } from '../models';
import { composeQuery, Query } from '../models/query';

export const getOrganizations = async (...criteria: Query<Organization>[]) => (await k1Axios.get<PageableResponse<Organization>>('/orgs', {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
  params: composeQuery<Organization>(...criteria),
  // must specify data to keep Content-Type header
  // though axios will remove request body when using GET method.
  data: {},
})).data;
